import * as React from "react";
import { IValueLabel } from "../model/ITriggerData";
import { default as DropdownInput} from "./DropdownInput";

export class TypedDropdownInput<T> extends React.PureComponent<TypedDropdownInputProps<T>, {}> {
    public render() {
        return <DropdownInput
            elementId={this.props.elementId}
            existingParameters={this.props.parameters}
            identifier={this.props.parameterName}
            dropdownModel={this.props.options}
            disabled={this.props.disabled}
            label={this.props.label}
            defaultValue={this.props.defaultValue}
        />;
    }
}

export interface TypedDropdownInputProps<T> {
    elementId: string;
    parameters: T;
    parameterName: keyof (T) & string;
    options: IValueLabel[];
    defaultValue?: any;
    disabled?: boolean;
    label?: string;
}
